import { render } from "./FamilyList.vue?vue&type=template&id=3b4c7aa0&scoped=true"
import script from "./FamilyList.vue?vue&type=script&lang=js"
export * from "./FamilyList.vue?vue&type=script&lang=js"

import "./FamilyList.vue?vue&type=style&index=0&id=3b4c7aa0&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4c7aa0"]])

export default __exports__